function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Status/Meldingstatus/klaar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Balance/Meldingstatus/klaar",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  fill: "#63D100",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,8.93416331 L8.9957757,12.5333333 C10.7941688,10.0201853 12.4622436,8.24240748 14,7.2",
  id: "Path-2-Copy",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
function SvgReservationEnabledCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Status/Meldingstatus/klaar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationEnabledCheck);
export default __webpack_public_path__ + "static/media/Reservation_EnabledCheck.cc0f5455fd6e706726f8ffab028426a4.svg";
export { ForwardRef as ReactComponent };